module.exports = __webpack_public_path__ + "static/media/tm.2c41cd01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tm.svg
// module id = 267
// module chunks = 0